class ToolsSlider extends HTMLElement {
  connectedCallback() {
    this.slideshow = this.querySelector('.tools-slider__slideshow');
    if (!this.slideshow || !this.slideshow.matches('[step]')) return;

    Object.defineProperty(this.slideshow, 'previousIndex', {
      get: function () {
        return this.current - 1;
      },
    });
    Object.defineProperty(this.slideshow, 'nextIndex', {
      get: function () {
        return this.current + 1;
      },
    });
  }
}

if (!customElements.get('tools-slider')) {
  customElements.define('tools-slider', ToolsSlider);
}
